/** @format */

import { NAME_PORTAL_CODE } from '../utils/gatsby/constants';
import { TRoom } from '@/ducks/room/declarations';

import { Axios } from '../utils/gatsby/createAxiosInstance';
import { utilitySetControllerTimeEnd } from '../utils/helpers/utilitySetControllerTimeEnd';

export const apiRoomAlternatives = async ({
  language,
  bedCode,
  checkInDate,
  buildingId,
  bedAlternativesSearchBy,
  portalCode = NAME_PORTAL_CODE,
  controller,
}: {
  language: string;
  bedCode: string;
  checkInDate: string;
  buildingId: string;
  bedAlternativesSearchBy: string;
  portalCode?: string | null;
  controller?: AbortController;
}): Promise<{ items: TRoom[] }> => {
  const signal = controller ? controller.signal : undefined;

  try {
    const timeoutId = controller && utilitySetControllerTimeEnd(controller);
    const response = await Axios.get(
      `/Beds/${bedCode}/Alternatives?portalCode=${portalCode}&checkInDate=${checkInDate}&bedAlternativesSearchBy=${bedAlternativesSearchBy}&buildingId=${buildingId}&language=${language}`,
      { signal },
    );
    if (response.status !== 200) throw new Error('/questions/error-room-alternative');
    if (response) clearTimeout(timeoutId);
    return response.data;
  } catch (error) {
    throw error;
  }
};
